import { lazyLoad } from 'utils/loadable';
import { Navigate } from 'react-router-dom';
import { PartnersSubMenuRoutes } from 'modules/Partners/partnersConfigPages';

const PartnersPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PartnersPage', webpackPrefetch: true */ './index'
  ),
);

const CustomersManagementPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CustomersManagementPage', webpackPrefetch: true */ './Components/CustomerManagement/index'
  ),
);

const PartnersDashboardPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PartnersDashboardPage', webpackPrefetch: true */ './Components/Dashboard/index'
  ),
);

const LeadManagementPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LeadManagementPage', webpackPrefetch: true */ './Components/LeadManagement/index'
  ),
);

export const aiAgentMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        {
          component: LeadManagementPage,
          title: 'Lead Management',
          path: PartnersSubMenuRoutes.LEAD_MANAGEMENT,
        },
        {
          component: CustomersManagementPage,
          title: 'Customers',
          path: PartnersSubMenuRoutes.CUSTOMER_MANAGEMENT,
        },
        {
          component: PartnersDashboardPage,
          title: 'Dashboard',
          path: PartnersSubMenuRoutes.DASHBOARD,
        },
      ]
    : []),
];

// routes declaration
export const partnersRoutes = [
  {
    component: Navigate,
    path: '/partners-in',

    replace: true,
    to: '/partners-in' + PartnersSubMenuRoutes.DEFAULT,
    toAdmin: '/partners-in' + PartnersSubMenuRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: PartnersPage,
    title: 'Partners',
    path: '/partners-in/*',
    needsAuth: true,
  },
];
